import {IOrganization} from "../interfaces/IOrganization";

export const initialOrganizationObj: IOrganization = {
    _id:"",
    name:"",
    publisherLogin:{},
    foreingAccess:{},
}